/// <reference types="vite/client" />
// apps/web/src/lib/apiBase.ts
// Where API calls go. Web: same-origin (""). Native app with bundled assets:
// the production API absolutely. VITE_API_BASE overrides for device testing
// against a local wrangler server (see the Phase C dev workflow).
import { Capacitor } from "@capacitor/core";

// Uses the REAL platform check, not isNativeApp() — the localhost force-native
// dev flag flips UI/routing for browser verification but must NOT reroute the
// API to production (that would CORS-block a local dev session).
export const API_BASE: string =
  (import.meta.env.VITE_API_BASE as string | undefined) ??
  (Capacitor.isNativePlatform() ? "https://caloly.com" : "");
